import { Lightning } from "@styled-icons/bootstrap";
import { QuickAction } from "types/Widget";

import { WidgetAction } from "./BlankAction";

export const SpotlightAction: QuickAction = ({ dashboardActions }) => {
  const { spotlightWidget } = dashboardActions;

  const onClickAction = () => {
    spotlightWidget();
  };

  return (
    <WidgetAction onClick={onClickAction}>
      <Lightning height="100%" color="var(--primary)" />
      <p>Feature</p>
    </WidgetAction>
  );
};
